const BASE_API = process.env.REACT_APP_ROUTE_API;
const headers = {Accept: 'application/json','Content-Type': 'application/json'};

export default {
  save: async (data, token) => {
    data.token = token;
    try {
      let req;
      req = await fetch(`${BASE_API}site/aluno/` + data.id + `?token=` + token, {
        method: 'POST', //Todo verificar cors 403 put
        headers: headers,
        body: JSON.stringify(data) 
      });
      
      const json = await req.json();
            json.statusRetorno = req.status;

      return json;
    } catch (error) {
      return error;
    }
  },
  getAlunoPorUserId: async (userId, token) => {
    try {
      const req = await fetch(`${BASE_API}site/aluno/${userId}?token=` + token, {
        method: 'GET',
        headers: headers,
      });
      const json = await req.json();
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      console.log(error);
    }
  },
  dadosInscricao: async (userId, tipoEvento,token) => {
    try {
      const req = await fetch(`${BASE_API}site/dadosAtleta/${userId}/${tipoEvento}?token=` + token, {
        method: 'GET',
        headers: headers,
      });
      const json = await req.json();
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      console.log(error);
    }
  },
  getAlunoPorCpf: async (cpf, token) => {
    try {
      const req = await fetch(`${BASE_API}site/obter-aluno-por-cpf/${cpf}`, {
        method: 'GET',
        headers: headers,
      });
      const json = await req.json();
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      console.log(error);
    }
  },
  novoAtleta: async (data) => {
    try {
      let req;
      req = await fetch(`${BASE_API}site/novo-aluno`, {
        method: 'POST', //Todo verificar cors 403 put
        headers: headers,
        body: JSON.stringify(data) 
      });
      
      const json = await req.json();
            json.statusRetorno = req.status;
      return json;
    } catch (error) {
      return error;
    }
  },
}